/*
 * Copyright 2019 FedEx
 */
import { Pipe, PipeTransform } from '@angular/core';
import { LanguageTranslationService } from './services/language-translation.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {

  constructor(private languageTranslationService: LanguageTranslationService) { }
  transform(key: string): any {
    var value = this.languageTranslationService.lang_data[key];
    if (value === undefined){
      return "";
    }
    return value;
  }

}
